(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-page-content')) {
    customElements.define(
      'faq-page-content',
      class FaqPageContent extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';

          this.source = this.querySelector('[data-faq-source]');
          this.intro = this.querySelector('[data-faq-intro]');
          this.list = this.querySelector('[data-faq-list]');
          if (!this.source || !this.intro || !this.list) return;

          const selector = this.dataset.questionSelector || 'h3';
          const children = Array.from(this.source.children);
          const questions = children.filter((node) => node.matches(selector));
          if (!questions.length) return;

          const hideContentHeading = this.dataset.hideContentHeading === 'true';
          const showIntro = this.dataset.showIntro === 'true';
          const firstOpen = this.dataset.firstOpen === 'true';
          let currentAnswer = null;
          let itemIndex = 0;

          children.forEach((node) => {
            if (node.matches(selector)) {
              const item = this.createItem(node, itemIndex);
              this.list.append(item.details);
              currentAnswer = item.answer;
              itemIndex += 1;
              return;
            }

            if (node.tagName === 'HR') return;
            if (hideContentHeading && node.tagName === 'H1') return;

            if (currentAnswer) {
              currentAnswer.append(node);
            } else if (showIntro) {
              this.intro.append(node);
            }
          });

          this.source.hidden = true;
          this.list.hidden = false;
          if (showIntro && this.intro.children.length) this.intro.hidden = false;

          const items = this.list.querySelectorAll('.faq-page__item');
          items.forEach((details, index) => {
            const summary = details.querySelector('summary');
            summary.setAttribute('aria-expanded', String(firstOpen && index === 0));
            if (firstOpen && index === 0) details.open = true;
            summary.addEventListener('click', (event) => this.handleToggle(event, details));
          });
        }

        createItem(heading, index) {
          const details = document.createElement('details');
          details.className = 'faq-page__item';

          const summary = document.createElement('summary');
          summary.className = 'faq-page__question';
          summary.id = `FaqQuestion-${index}-${Math.random().toString(36).slice(2, 8)}`;

          const questionText = document.createElement('span');
          questionText.className = 'faq-page__question-text';
          while (heading.firstChild) questionText.append(heading.firstChild);

          const icon = document.createElement('span');
          icon.className = 'faq-page__icon';
          icon.setAttribute('aria-hidden', 'true');

          const answer = document.createElement('div');
          answer.className = 'faq-page__answer-inner rte text-subtext';

          const answerWrapper = document.createElement('div');
          answerWrapper.className = 'faq-page__answer';
          answerWrapper.setAttribute('role', 'region');
          answerWrapper.setAttribute('aria-labelledby', summary.id);
          answerWrapper.append(answer);

          summary.append(questionText, icon);
          details.append(summary, answerWrapper);
          return { details, answer };
        }

        handleToggle(event, details) {
          event.preventDefault();
          const shouldOpen = !details.open;

          if (shouldOpen && this.dataset.allowMultiple !== 'true') {
            this.list.querySelectorAll('.faq-page__item[open]').forEach((item) => {
              if (item !== details) this.setItemState(item, false);
            });
          }

          this.setItemState(details, shouldOpen);
        }

        setItemState(details, shouldOpen) {
          const summary = details.querySelector('summary');
          const answer = details.querySelector('.faq-page__answer');
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (details.faqAnimation) details.faqAnimation.cancel();
          summary.setAttribute('aria-expanded', String(shouldOpen));

          if (reduceMotion || !answer.animate) {
            details.open = shouldOpen;
            return;
          }

          if (shouldOpen) {
            details.open = true;
            const height = answer.scrollHeight;
            details.faqAnimation = answer.animate(
              [
                { height: '0px', opacity: 0 },
                { height: `${height}px`, opacity: 1 }
              ],
              { duration: 220, easing: 'ease-out' }
            );
          } else {
            const height = answer.offsetHeight;
            details.faqAnimation = answer.animate(
              [
                { height: `${height}px`, opacity: 1 },
                { height: '0px', opacity: 0 }
              ],
              { duration: 180, easing: 'ease-in' }
            );
            details.faqAnimation.addEventListener('finish', () => {
              details.open = false;
            }, { once: true });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["installment-providers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('installment-providers')) {
    customElements.define(
      'installment-providers',
      class InstallmentProviders extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';
          this.addEventListener('click', this.handleClick.bind(this));
          this.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
        }

        handleClick(event) {
          const filter = event.target.closest('[data-provider-filter]');
          if (filter && this.contains(filter)) {
            this.applyFilter(filter.dataset.providerFilter);
            return;
          }

          const opener = event.target.closest('[data-dialog-open]');
          if (opener && this.contains(opener)) {
            const dialog = this.querySelector(`#${CSS.escape(opener.dataset.dialogOpen)}`);
            if (dialog && !dialog.open) dialog.showModal();
            return;
          }

          const closer = event.target.closest('[data-dialog-close]');
          if (closer && this.contains(closer)) {
            const dialog = closer.closest('dialog');
            if (dialog) dialog.close();
            return;
          }

          if (event.target instanceof HTMLDialogElement) event.target.close();
        }

        handleBlockSelect(event) {
          const card = event.target.closest('[data-provider-card]');
          if (!card) return;
          this.applyFilter(card.dataset.providerType);
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        applyFilter(value) {
          let visibleCount = 0;
          const grid = this.querySelector('[data-provider-grid]');
          if (grid) grid.dataset.activeFilter = value;

          this.querySelectorAll('[data-provider-group]').forEach((group) => {
            const visible = value === 'all' || group.dataset.providerType === value;
            group.hidden = !visible;
            if (visible) visibleCount += group.querySelectorAll('[data-provider-card]').length;
          });

          this.querySelectorAll('[data-provider-filter]').forEach((button) => {
            const active = button.dataset.providerFilter === value;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });

          const emptyState = this.querySelector('[data-empty-state]');
          if (emptyState) emptyState.hidden = visibleCount > 0;

          const status = this.querySelector('[data-filter-status]');
          if (status) status.textContent = this.dataset.resultsText.replace('[count]', String(visibleCount));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
